/* tslint:disable */
/* eslint-disable */
/**
 * Microsoft Graph Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserInfo } from './UserInfo';
import {
    UserInfoFromJSON,
    UserInfoFromJSONTyped,
    UserInfoToJSON,
    UserInfoToJSONTyped,
} from './UserInfo';

/**
 * 
 * @export
 * @interface GetUsersBySurname200Response
 */
export interface GetUsersBySurname200Response {
    /**
     * 
     * @type {Array<UserInfo>}
     * @memberof GetUsersBySurname200Response
     */
    value?: Array<UserInfo>;
    /**
     * 
     * @type {string}
     * @memberof GetUsersBySurname200Response
     */
    odataNextLink?: string;
    /**
     * 
     * @type {number}
     * @memberof GetUsersBySurname200Response
     */
    odataCount?: number;
}

/**
 * Check if a given object implements the GetUsersBySurname200Response interface.
 */
export function instanceOfGetUsersBySurname200Response(value: object): value is GetUsersBySurname200Response {
    return true;
}

export function GetUsersBySurname200ResponseFromJSON(json: any): GetUsersBySurname200Response {
    return GetUsersBySurname200ResponseFromJSONTyped(json, false);
}

export function GetUsersBySurname200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsersBySurname200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(UserInfoFromJSON)),
        'odataNextLink': json['@odata.nextLink'] == null ? undefined : json['@odata.nextLink'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function GetUsersBySurname200ResponseToJSON(json: any): GetUsersBySurname200Response {
    return GetUsersBySurname200ResponseToJSONTyped(json, false);
}

export function GetUsersBySurname200ResponseToJSONTyped(value?: GetUsersBySurname200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(UserInfoToJSON)),
        '@odata.nextLink': value['odataNextLink'],
        '@odata.count': value['odataCount'],
    };
}

